import React, {useEffect, useState} from "react";
import axiosInstance from "../../../../variables/api/axiosInstance";
import {Button, Empty, Table, Tabs} from "antd";
import {useNavigate} from "react-router-dom";
import {formatFrenchDate, isConnectedUser, isConnectedUserFromPOOL} from "../../../../variables/functions";

const PoolAttestations = () => {
    const [commandes, setCommandes] = useState([])
    const [loadingOrders, setLoadingOrders] = useState(false)
    const [selectedOrder, setSelectedOrder] = useState({})
    const navigate = useNavigate()
    useEffect(() => {
        axiosInstance
            .get(`/api/bon-commande`)
            .then((res) => {
                setCommandes(res.data.reverse());
                setLoadingOrders(false);
            })
            .catch(() => setLoadingOrders(false));
    }, []);
    const approved = commandes?.filter((com) => com.statutCommande === 'APPROUVE')
    const handledCommandes = commandes?.filter((com) => com.statutCommande === 'RECEPTIONNE' || com.statutCommande === 'DELIVRE')

    const compagnieColumns = [
        {
            title: "Numero de commande",
            dataIndex: "numero",
            key: "code",
            render: (_, record) => (<>{record?.codeId} </>),
        },
        {
            title: "Initiée par",
            dataIndex: "initiateur",
            key: "initiateur",
            editable: false,
            render: (_, record) => (<>
                {isConnectedUser(record?.actionsSurCommande) ? (<>
                    Vous
                </>) : (<>
                    {record?.emetteur?.personne?.nom} {record.emetteur?.personne?.prenom}

                </>)}
            </>)
        }, {
            title: "Montant", dataIndex: 'montant', key: 'montant', render: (_, record) => (<>
                {record?.reglement?.montant}
            </>)
        }, {
            title: "Date de Commande",
            dataIndex: "dateEmission",
            key: "dateEmission",
            editable: false,
            render: (_, record) => <>{formatFrenchDate(record.dateEmission)}</>,
        },];

    const expandedRowRender = (record) => (<div
        style={{
            padding: "16px", background: "#f9f9f9", display: "flex", justifyContent: "center", gap: "16px",
        }}
    >
        {record?.statutCommande === 'APPROUVE' && !isConnectedUserFromPOOL() ? (<>
            <Button
                type="default"
                style={{
                    backgroundColor: "#1a347d", borderColor: "#4c757d", color: "white",
                }}
                icon={<i className="bx bx-detail"></i>}
                onClick={() => {
                    setSelectedOrder(record);
                    navigate(`/caisse/attestation/${record?.codeId}`)
                }}
            >
                Notifier le reglement
            </Button>
        </>) : (<Button
            type="default"
            style={{
                backgroundColor: "#1a347d", borderColor: "#4c757d", color: "white",
            }}
            icon={<i className="bx bx-detail"></i>}
            onClick={() => {
                setSelectedOrder(record);
                navigate(`/commande/${record?.codeId}`)
            }}
        >
            Details de la commande
        </Button>)}

    </div>);

    const columns = [
        {
            title: "Numero de commande",
            dataIndex: "numero",
            key: "code",
            render: (_, record) => (<>{record?.codeId} </>),
        }, {
            title: "Compagnie",
            dataIndex: "compagnie",
            key: "1",
            render: (_, record) => (<>{record?.compagnie?.raisonSociale} </>),
        },
        {
            title: "Montant", dataIndex: 'montant', key: 'montant', render: (_, record) => (<>
                {record?.reglement?.montant}
            </>)
        }, {
            title: "Date de Commande",
            dataIndex: "dateEmission",
            key: "dateEmission",
            editable: false,
            render: (_, record) => <>{formatFrenchDate(record.dateEmission)}</>,
        },];

    return (<>
        <Tabs defaultActiveKey="1">
            <Tabs.TabPane tab="Enregistrement de règlement" key="1">
                {approved?.length === 0 ? (<>
                    <Empty
                        description={`Aucune facture à régler`}
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        style={{marginTop: 32}}
                    />
                </>) : (<>
                    <Table
                        columns={isConnectedUserFromPOOL() ? columns : compagnieColumns}
                        dataSource={approved}
                        rowKey="codeId"
                        expandable={{
                            expandedRowRender,
                        }}
                    />
                </>)}
            </Tabs.TabPane>
            <Tabs.TabPane tab={"Anciens reglements"}>
                <Table
                    columns={isConnectedUserFromPOOL() ? columns : compagnieColumns}
                    dataSource={handledCommandes}
                    rowKey="codeId"
                    expandable={{
                        expandedRowRender,
                    }}
                />
            </Tabs.TabPane>

        </Tabs>

    </>)
}

export default PoolAttestations